export interface PhotographyTag {
  icon: string,
  label: string
}

export const PHOTOGRAPHY_TAGS: PhotographyTag[] = [
  // Photography Types / Specialties
  { icon: "💍", label: "wedding" },
  { icon: "❤️", label: "engagement" },
  { icon: "🌄", label: "elopement" },
  { icon: "🧑", label: "portrait" },
  { icon: "🏡", label: "lifestyle" },
  { icon: "👨‍👩‍👧‍👦", label: "family" },
  { icon: "🤰", label: "maternity" },
  { icon: "👶", label: "newborn" },
  { icon: "🍼", label: "baby" },
  { icon: "💑", label: "couple" },
  { icon: "🎉", label: "event" },
  { icon: "💼", label: "corporate" },
  { icon: "📦", label: "product" },
  { icon: "👗", label: "fashion" },
  { icon: "📰", label: "editorial" },
  { icon: "🏙️", label: "commercial" },
  { icon: "🏠", label: "real-estate" },
  { icon: "🏛️", label: "architecture" },
  { icon: "🍽️", label: "food" },
  { icon: "✈️", label: "travel" },
  { icon: "🚶", label: "street" },
  { icon: "🍃", label: "nature" },
  { icon: "🦁", label: "wildlife" },
  { icon: "⚽", label: "sports" },
  { icon: "🏎️", label: "automotive" },
  { icon: "🚁", label: "aerial" },
  { icon: "🌊", label: "underwater" },
  { icon: "💋", label: "boudoir" },
  { icon: "🎨", label: "fine-art" },
  { icon: "🧠", label: "conceptual" },

  // Photographer Style
  { icon: "🌞", label: "natural-light" },
  { icon: "💡", label: "studio" },
  { icon: "📷", label: "candid" },
  { icon: "🧍", label: "posed" },
  { icon: "📖", label: "documentary" },
  { icon: "🎬", label: "cinematic" },
  { icon: "🌫️", label: "moody" },
  { icon: "🌤️", label: "bright-and-airy" },
  { icon: "📼", label: "vintage" },
  { icon: "⚪", label: "minimalist" },
  { icon: "🌀", label: "abstract" },

  // Service Tags
  { icon: "🎓", label: "professional" },
  { icon: "👶", label: "amateur" },
  { icon: "🎯", label: "hobbyist" },
  { icon: "🌍", label: "available-worldwide" },
  { icon: "📍", label: "local-only" },
  { icon: "💎", label: "high-end" },
  { icon: "💸", label: "affordable" },
  { icon: "⚡", label: "quick-delivery" },
  { icon: "🖌️", label: "retouching-included" },
  { icon: "🖼️", label: "prints-available" },
  { icon: "📚", label: "photo-album" },
  { icon: "⏱️", label: "same-day-delivery" },
  { icon: "🏢", label: "studio-provided" },
  { icon: "🌄", label: "on-location" },

  // Shooting Context
  { icon: "🏠", label: "indoor" },
  { icon: "🌳", label: "outdoor" },
  { icon: "🏙️", label: "urban" },
  { icon: "🌾", label: "rural" },
  { icon: "🏖️", label: "beach" },
  { icon: "🌲", label: "forest" },
  { icon: "🧳", label: "destination" }
];

export function getTagIconFromLabel(label: string): string | undefined {
  const tag = PHOTOGRAPHY_TAGS.find(tag => tag.label === label);
  return tag ? tag.icon : undefined;
}
